module.exports = __webpack_public_path__ + "img/worksbot_img19122404.e0a09c46.jpg";